/// Port of mobile/lib/user/data/user_local_data.dart.
/// The guest high score, kept out of the API entirely.

const anonymousHighScoreKey = 'anonymousHighScore';

export function readAnonymousHighScore(): number {
  try {
    const raw = localStorage.getItem(anonymousHighScoreKey);
    const parsed = raw === null ? 0 : Number.parseInt(raw, 10);
    return Number.isFinite(parsed) && parsed > 0 ? parsed : 0;
  } catch {
    return 0;
  }
}

export function writeAnonymousHighScore(score: number): void {
  try {
    localStorage.setItem(anonymousHighScoreKey, String(score));
  } catch {
    // Non-fatal: the guest score just will not survive a reload.
  }
}

export function clearAnonymousHighScore(): void {
  try {
    localStorage.removeItem(anonymousHighScoreKey);
  } catch {
    // Ignored for the same reason as above.
  }
}

function autoUsernamePromptDismissedKey(userId: string): string {
  return `autoUsernamePromptDismissed_${userId}`;
}

export function isAutoUsernamePromptDismissed(userId: string): boolean {
  try {
    return localStorage.getItem(autoUsernamePromptDismissedKey(userId)) === '1';
  } catch {
    return false;
  }
}

export function setAutoUsernamePromptDismissed(userId: string): void {
  try {
    localStorage.setItem(autoUsernamePromptDismissedKey(userId), '1');
  } catch {
    // Non-fatal.
  }
}
